function Other1(props)
{
    return(
        <svg className={props.class} style={{...props.style}} viewBox="0 0 480 480"><path d="M480 0H0l240 240L480 0zM0 480h480L240 240 0 480z"></path></svg>
    )
}

export default Other1